export const LIST_MASONRY_MIN_ITEM = 2
export const LIST_MASONRY_MIN_ITEM_DIVIDER = 240
export const LIST_MASONRY_MAX_ITEM = 3
export const LIST_MASONRY_MAX_ITEM_DIVIDER = 160
export const LIST_MASONRY_MAX_RATIO = 3
export const LIST_MASONRY_MAX_RATIO_DIVIDER = 200
export const LIST_MASONRY_MIN_RATIO_PER_ITEM = 0.5
export const LIST_MASONRY_MAX_RATIO_PER_ITEM = 2.5
export const LIST_MASONRY_LOAD_LIMIT = 20
